import { useState, useEffect } from 'react';

/**
 * Hook to handle hydration state
 * Prevents hydration mismatches by ensuring client-side rendering
 */
export const useHydration = () => {
  const [isHydrated, setIsHydrated] = useState(false);

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  return isHydrated;
};